import InstagramTaggedProductSchema from "@apps/instagram/schemas/InstagramTaggedProductSchema";
import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { Observable } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";
import { create } from "superstruct";
import { injectable } from "tsyringe";

import { LoggerInterface } from "@interfaces/LoggerInterface";

import InstagramTaggedProductEntity from "../../entities/InstagramTaggedProductEntity";
import InstagramTaggedProductStore from "../../stores/InstagramTaggedProductStore";
import InstagramTaggedProductServiceInterface from "./InstagramTaggedProductServiceInteface";

@injectable()
class InstagramTaggedProductService
    implements InstagramTaggedProductServiceInterface
{
    constructor(
        private instagramTaggedProductStore: InstagramTaggedProductStore,
        private readonly apiClient: ApiClientInterface,
        private readonly logger: LoggerInterface
    ) {}
    getTaggedProductByProductId(
        productId: number
    ): Observable<InstagramTaggedProductEntity> {
        this.logger.debug(
            "InstagramTaggedProductService.getTaggedProductByProductId is started",
            { productId }
        );
        return this.apiClient
            .get({
                url: "/instagram/getTaggedProduct",
                queryParams: {
                    id: productId,
                },
            })
            .pipe(
                map((v) => {
                    return create(v.body, InstagramTaggedProductSchema);
                }),
                catchError((error: unknown) => {
                    this.logger.debug(
                        "InstagramTaggedProductService.getTaggedProductByProductId is errored",
                        { productId }
                    );
                    this.instagramTaggedProductStore.setError(true);
                    throw error;
                }),
                tap((v) => {
                    this.logger.debug(
                        "InstagramTaggedProductService.getTaggedProductByProductId is ready",
                        { productId }
                    );
                    this.instagramTaggedProductStore.update(() => ({
                        product: v,
                    }));
                })
            );
    }
}

export default InstagramTaggedProductService;
